import React, { useEffect, useRef, useState } from 'react';
import axios from "axios";
import { baseurl } from "../utility/helper";
import { Link, useNavigate  } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../assets/css/Header1.css';
import '../assets/css/sidebar.css';
import Swal from "sweetalert2";
import $ from 'jquery';

const Header1 = () => {
  const navigate = useNavigate();
  const roleid = parseInt(sessionStorage.getItem("userroleId"));
  const chaptername = sessionStorage.getItem("userchaptername");
  const username = sessionStorage.getItem("username");
  const profilePic = sessionStorage.getItem("adminImg");
  const [isOpen, setIsOpen] = useState(false);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [openSubmenus, setOpenSubmenus] = useState({});
  const dropdownRef = useRef(null);

  const handleLogout = () => {
    // Clear session storage/local storage
    localStorage.clear();
    sessionStorage.clear();

    // Call dropdown close if needed
    if (closeDropdown) closeDropdown();

    // Replace history so user cannot go back
    navigate("/", { replace: true });

    // Optional: force reload to clear any cached state
    window.location.reload();
  };

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const closeDropdown = () => {
    setIsOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleBackup = async () => {

  Swal.fire({
    title: "Processing...",
    text: "Please wait while the database backup is being generated.",
    allowOutsideClick: false,
    allowEscapeKey: false,
    didOpen: () => {
      Swal.showLoading();
    }
  });

  try {

    const response = await axios.get(
      `${baseurl}/admin/backup-database`,
      {
        responseType: "blob"
      }
    );

    // Get filename from header
    const disposition = response.headers["content-disposition"];
    let filename = "database_backup.dump";

    if (disposition && disposition.includes("filename=")) {
      filename = disposition.split("filename=")[1].replace(/"/g, "");
    }

    const blob = new Blob([response.data]);
    const url = window.URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = filename;

    document.body.appendChild(link);
    link.click();

    link.remove();
    window.URL.revokeObjectURL(url);

    Swal.close();

    Swal.fire({
      icon: "success",
      title: "Backup Complete",
      text: "Database backup downloaded successfully."
    });

  } catch (error) {

    Swal.close();

    Swal.fire({
      icon: "error",
      title: "Backup Failed",
      text: "Unable to generate database backup."
    });

  }
};

  // Function to toggle submenu visibility
  const toggleSubMenu = (menu) => {
    setOpenSubmenus((prev) => {
      // If clicked submenu is already open -> close it
      if (prev[menu]) {
        return { [menu]: false };
      }
      // Otherwise -> close all others & open only this one
      return { [menu]: true };
    });
  };


  const handleSubMenuItemClick = (menu) => {
    // Collapse the submenu when an item is clicked
    setOpenSubmenus((prev) => ({
      ...prev,
      [menu]: true, // Close the submenu
    }));
  };

  const toggleSidebar = () => {
    if (!isSidebarOpen) {
      setIsSidebarOpen(true); // Ensure it's true first
      $(".page-wrapper").addClass("expandpage3");
    } else {
      setIsSidebarOpen(false); // Toggle off on next click
      $(".page-wrapper").removeClass("expandpage3");
      $(".page-wrapper").addClass("");
    }
  };

  const closeSidebar = () => {
    setIsSidebarOpen(false);
    $(".page-wrapper").removeClass("expandpage3");
  };

  return (
    <div>
      <div className="main-wrapper">
        <div className="header header-one">

          <a className="mobile_btn" id="mobile_btn" onClick={toggleSidebar}>
            <i className={`fa ${isSidebarOpen ? "fa-times" : "fa-bars"}`}></i>
          </a>

          <ul className="nav nav-tabs user-menu" >

            <li className="nav-item dropdown" ref={dropdownRef}>
              <a className="user-link nav-link" onClick={toggleDropdown}>
                <span className="user-img">
                  <img src={profilePic || "https://bootdey.com/img/Content/avatar/avatar7.png"}
                                            alt="add image"
                                            name="images"
                                            className="img-fluid"
                                            style={{ objectFit: "fit-height" }} />
                  <span className="animate-circle"></span>
                </span>
                <span className="user-content">
                  {roleid === 1 && (
                    <div>
                      <span className="user-details">SuperAdmin</span>
                      <span className="user-name">{username}</span>
                    </div>
                  )}

                  {roleid === 2 && (
                    <div>
                      <span className="user-details">Admin</span>
                      <span className="user-name">{username}</span>
                    </div>
                  )}

                  {roleid === 4 && (
                    <div>
                      <span className="user-details">Test Admin</span>
                      <span className="user-name">{username}</span>
                    </div>
                  )}

                  {roleid === 5 && (
                    <div>
                      <span className="user-details">Transaction Admin</span>
                      <span className="user-name">{username}</span>
                    </div>
                  )}

                  {roleid === 3 && (
                    <div>
                      <span className="user-details">Manager Admin</span>
                      <span className="user-name">{username}</span>
                    </div>
                  )}

                </span>
              </a>
              {isOpen && (
                <div className="" style={{ borderRadius: '10%', backgroundColor: 'white', width: '100%', boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)' }}>
                  <div className="profilemenu">
                    <div className="subscription-menu">
                      <ul style={{ padding: '0' }}>
                        <li>
                          <Link className="dropdown-item" to="/admin/AdminProfile" style={{ fontSize: '15px', fontWeight: '600' }} onClick={closeDropdown}>Profile</Link>
                        </li>
                      </ul>
                    </div>
                    <div className="subscription-logout">
                      <ul style={{ padding: '0' }}>
                        <li className="pb-0">
                          <Link className="dropdown-item" to="./" style={{ fontSize: '15px', fontWeight: '600' }} onClick={handleLogout}>Log Out</Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              )}
            </li>

          </ul>

        </div>

        {/* Mobile overlay backdrop */}
        {isSidebarOpen && (
          <div className="sidebar-overlay" onClick={closeSidebar}></div>
        )}

        {/* Sidebar */}
        <div className={`sidebar ${isSidebarOpen ? "active" : ""}`} id="sidebar">
          <div className="main-logo d-inline float-start d-lg-flex align-items-center">

            <div className="logo-white">

              <img src="/assets/img/mensatrans.png" className="img-fluid2 logo-blue" alt="Logo" />

            </div>
            <div className="logo-color">
              <a href="">
                <img src="" className="img-fluid logo-blue" alt="Logo" />
              </a>
              <a href="">
                <img src="" className="img-fluid logo-small" alt="Logo" />
              </a>
            </div>

            {isSidebarOpen && (
              <a className="sidebar-close-btn" onClick={closeSidebar}>
                <i className="fa fa-times"></i>
              </a>
            )}
          </div>
          <div className="sidebar-inner slimscroll">
            <div id="sidebar-menu" className="sidebar-menu">
              <ul
                className="sidebar-vertical"
                style={{ position: "absolute" }}
                onClick={(e) => {
                  const link = e.target.closest("a");
                  if (link && link.getAttribute("href") !== "#" && window.innerWidth <= 991.98) {
                    closeSidebar();
                  }
                }}
              >
                <li className="menu-title" style={{ justifyContent: "left" }}><span>Main</span></li>
                {((roleid !== 4 && roleid !== 5) || roleid === 1) && (
                  <li>
                    <Link to="/admin/Dashboard" onClick={() => toggleSubMenu("Dashboard")}><i className='fa fa-pie-chart'></i> <span> Dashboard</span></Link>
                  </li>
                )}
                {((roleid !== 4 && roleid !== 5) || roleid === 1) && (
                <li>
                  <Link to="/admin/MemberList" onClick={() => toggleSubMenu("Member")}><i className='fa fa-users'></i><span> Members</span></Link>
                </li>
                )}
                {((roleid !== 4 && roleid !== 5) || roleid === 1) && (
                <li>
                  <Link to="/admin/CandiAdd" onClick={() => toggleSubMenu("Candidate")}><i className='fa fa-users'></i><span> Candidate</span></Link>
                </li>
                )}
                {roleid !== 5 && (
                <li>
                  <Link to="/admin/TestList" onClick={() => toggleSubMenu("Test")}><i className='fa fa-file-text'></i><span> Test</span></Link>
                </li>
                )}
                {(roleid === 1 || roleid === 2) && (
                  <li className="submenu">
                    <a href="#" onClick={() => toggleSubMenu("institute")}>
                      <i className='fa fa-university'></i> <span>Institutes</span> <h5 className="menu-arrow"></h5>
                    </a>
                    <ul style={{ display: openSubmenus["institute"] ? "block" : "none" }}>
                      {roleid === 1 && (
                        <li><Link to="/admin/InstituteList" onClick={() => handleSubMenuItemClick("institute")}><i className='fa fa-university'></i><h7> Institutes</h7></Link></li>
                      )}
                      <li><Link to="/admin/BatchList" onClick={() => handleSubMenuItemClick("institute")}><i className='fa fa-layer-group'></i><h7> Batches</h7></Link></li>
                      {roleid === 1 && (
                        <li><Link to="/admin/BatchFeeApprovals" onClick={() => handleSubMenuItemClick("institute")}><i className='fa fa-check-square-o'></i><h7> Fee Approvals</h7></Link></li>
                      )}
                    </ul>
                  </li>
                )}
                {roleid === 1 && (
                <li>
                  <Link to="/admin/PreTestList" onClick={() => toggleSubMenu("PreTest")}><i className='fa fa-file-text'></i><span> Pre-Test</span></Link>
                </li>
                )}
                {(roleid === 1 || roleid === 4) && (
                <li>
                  <Link to="/admin/PriorEvidence" onClick={() => toggleSubMenu("Prior")}><i className='fa fa-file-text'></i><span> Prior-Evidence List</span></Link>
                </li>
                )}
               
                {roleid === 1 && (
                  <li>
                    <Link to="/admin/ChapterList" onClick={() => toggleSubMenu("Chapter")}><i className='fa fa-file-text'></i><span> Chapters</span></Link>
                  </li>
                )}
                {((roleid !== 4 && roleid !== 5) || roleid === 1) && (
                <li><Link to="/admin/Newseventlist" onClick={() => toggleSubMenu("news")}> <i className='fa fa-assistive-listening-systems'></i> <span> News & Events</span></Link></li>
                )}
                {((roleid !== 4 && roleid !== 5) || roleid === 1) && (
                <li><Link to="/admin/Testimoniallist" onClick={() => toggleSubMenu("Testimonial")}> <i className='fa fa-comment'></i><span> View Testimonial</span></Link></li>
                )}
                {roleid !== 4 && (
                <li>
                  <Link to="/admin/Transactionlist" onClick={() => toggleSubMenu("Transaction")}><i className='fa fa-credit-card'></i><span> Transaction List</span></Link>
                </li>
                )}
                {roleid === 1 && (

                  <li className="submenu">
                    <a href="#" onClick={() => toggleSubMenu("admin")}>
                      <i className='fa fa-user'></i> <span>Admin Management</span> <h5 className="menu-arrow"></h5>
                    </a>
                    <ul style={{ display: openSubmenus["admin"] ? "block" : "none" }}>
                      <li><Link to="/admin/Manageadmin" onClick={() => handleSubMenuItemClick("admin")}><i className='fa fa-user'></i><h7> Admin List</h7></Link></li>
                      <li><Link to="/admin/Addadmin" onClick={() => handleSubMenuItemClick("admin")}><i className='fa fa-user'></i><h7> Add/Edit Admins</h7></Link></li>
                    </ul>
                  </li>
                )}

                {roleid === 1 && (

                  <li className="submenu">
                    <a href="#" onClick={() => toggleSubMenu("website")}>
                      <i className='fa fa-user'></i> <span>Website Content</span> <h5 className="menu-arrow"></h5>
                    </a>
                    <ul style={{ display: openSubmenus["website"] ? "block" : "none" }}>
                      <li><Link to="/admin/PriortestAccept" onClick={() => handleSubMenuItemClick("website")}><i className='fa fa-user'></i><h7> Prior Evidence Tests</h7></Link></li>
                      <li><Link to="/admin/ContactsAdd" onClick={() => handleSubMenuItemClick("website")}><i className='fa fa-user'></i><h7> Contacts Add</h7></Link></li>
                      <li><Link to="/admin/MIndMagazine" onClick={() => handleSubMenuItemClick("website")}><i className='fa fa-user'></i><h7> MInd-Magazine Add</h7></Link></li>
                      <li><Link to="/admin/WebsiteCounting" onClick={() => handleSubMenuItemClick("website")}><i className='fa fa-user'></i><h7> Counting Add</h7></Link></li>
                      {/* <li><Link to="/admin/Addadmin" onClick={() => handleSubMenuItemClick("website")}><i className='fa fa-user'></i><h7> Add/Edit Admins</h7></Link></li> */}
                    </ul>
                  </li>
                )}

                {roleid === 1 && (
                  <li className="submenu">
                    <a href="#" onClick={() => toggleSubMenu("trash")}>
                      <i className='fa fa-trash'></i> <span>Trash Management</span> <h5 className="menu-arrow"></h5>
                    </a>
                    <ul style={{ display: openSubmenus["trash"] ? "block" : "none" }}>
                      <li><Link to="/admin/Testdeleted" onClick={() => handleSubMenuItemClick("trash")}><i className='fa fa-file-text'></i><h7> Deleted Test</h7></Link></li>
                      <li><Link to="/admin/Eventdeleted" onClick={() => handleSubMenuItemClick("trash")}><i className='fa fa-file-text'></i><h7> Deleted Event</h7></Link></li>
                      <li><Link to="/admin/Admindeleted" onClick={() => handleSubMenuItemClick("trash")}><i className='fa fa-file-text'></i><h7> Deleted Admin</h7></Link></li>
                      <li><Link to="/admin/Memberdeleted" onClick={() => handleSubMenuItemClick("trash")}><i className='fa fa-file-text'></i><h7> Deleted Member</h7></Link></li>
                    </ul>
                  </li>
                )}
                {((roleid !== 4 && roleid !== 5) || roleid === 1) && (
                <li className="submenu">
                    <a href="#" onClick={() => toggleSubMenu("transfer")}>
                      <i className='fa fa-exchange'></i> <span>Transfer List</span> <h5 className="menu-arrow"></h5>
                    </a>
                    <ul style={{ display: openSubmenus["transfer"] ? "block" : "none" }}>
                      <li><Link to="/admin/Interchapter" onClick={() => handleSubMenuItemClick("transfer")}><i className='fa fa-file-text'></i><h7> Interchapter</h7></Link></li>
                      <li><Link to="/admin/International" onClick={() => handleSubMenuItemClick("transfer")}><i className='fa fa-file-text'></i><h7> International</h7></Link></li>
                      {/* <li><Link to="/admin/Testdeleted" onClick={() => handleSubMenuItemClick("trash")}><i className='fa fa-file-text'></i><h7> Deleted Testimonial</h7></Link></li> */}
                    </ul>
                </li>
                )}
                {((roleid !== 4 && roleid !== 5) || roleid === 1) && (
                <li className="submenu">
                    <a href="#" onClick={() => toggleSubMenu("Order")}>
                      <i className='fa fa-address-card'></i> <span>Order List</span> <h5 className="menu-arrow"></h5>
                    </a>
                    <ul style={{ display: openSubmenus["Order"] ? "block" : "none" }}>
                      <li><Link to="/admin/CardList" onClick={() => handleSubMenuItemClick("Order")}><i className='fa fa-file-text'></i><h7> Card List</h7></Link></li>
                      <li><Link to="/admin/PlaqueList" onClick={() => handleSubMenuItemClick("Order")}><i className='fa fa-file-text'></i><h7> Plaque List</h7></Link></li>
                      {/* <li><Link to="/admin/Testdeleted" onClick={() => handleSubMenuItemClick("trash")}><i className='fa fa-file-text'></i><h7> Deleted Testimonial</h7></Link></li> */}
                    </ul>
                </li>
                )}
                
                  {/* Submenu Reports */}
                  {((roleid !== 4 && roleid !== 5) || roleid === 1) && (
                <li className="submenu">
                  <a href="#" onClick={() => toggleSubMenu("reports")}>
                    <i className='fa fa-bar-chart'></i> <span>Reports</span> <h5 className="menu-arrow"></h5>
                  </a>
                  <ul style={{ display: openSubmenus["reports"] ? "block" : "none" }}>
                    <li><Link to="/admin/MemberReports" onClick={() => handleSubMenuItemClick("reports")}><h7>Member Repor</h7>t</Link></li>
                    <li><Link to="/admin/CandidateReports" onClick={() => handleSubMenuItemClick("reports")}><h7>Candidate Report</h7></Link></li>
                    <li><Link to="/admin/TestReports" onClick={() => handleSubMenuItemClick("reports")}><h7>Test Report</h7></Link></li>
                  </ul>
                </li>
                  )}
                {/* Submenu Testimonials */}
                {roleid === 1 && (
                <li className="submenu">
                  <a href="#" onClick={() => toggleSubMenu("settings")}>
                    <i className='fa fa-cog'></i> <span> Settings</span> <h5 className="menu-arrow"></h5>
                  </a>
                  <ul style={{ display: openSubmenus["settings"] ? "block" : "none" }}>
                    <li><Link to="/admin/fees" onClick={() => handleSubMenuItemClick("settings")}><h7>Manage Fees</h7></Link></li>
                  </ul>
                  <ul style={{ display: openSubmenus["settings"] ? "block" : "none" }}>
                    <li><Link to="/admin/EmailSetting" onClick={() => handleSubMenuItemClick("settings")}><h7>Email Setting</h7></Link></li>
                  </ul>
                  <ul style={{ display: openSubmenus["settings"] ? "block" : "none" }}>
                    <li><Link to="/admin/PaymentSetting" onClick={() => handleSubMenuItemClick("settings")}><h7>Payment Setting</h7></Link></li>
                  </ul>
                </li>
                )}
                {/* {roleid === 1 && (
                <li>
                  <a href="#" onClick={handleBackup}>
                    <i class="fa fa-file" aria-hidden="true"></i>
                    <span>Backup Database</span>
                  </a>
                </li>
                )} */}

              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header1;
